import { createEntityAdapter } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ExtensiveAttributeModel } from 'types/entity';

export const extensiveAttributeDefinitionReadAdapter = createEntityAdapter<ExtensiveAttributeModel>({
  selectId: (model) => model.extensive_attribute_definition_id || '',
  sortComparer: (e1, e2) => {
    const id1 = e1.extensive_attribute_definition_id || '';
    const id2 = e2.extensive_attribute_definition_id || '';
    if (id1 > id2) {
      return 1;
    }
    return id1 === id2 ? 0 : -1;
  },
});

export const {
  selectById: select,
  selectAll: selectAllExtensiveAttributeDefinition,
} = extensiveAttributeDefinitionReadAdapter.getSelectors<RootState>((state) => state.extensiveAttributeDefinitionRead);
